import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { useContextSelector } from 'use-context-selector';
import { ViewCatalogProductsContext } from '../ViewCatalogProductsContext';

const BrandNameCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);
  const selectedCatalog = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.selectedCatalog
  );
  const isExternalSupplier = !!(selectedCatalog && selectedCatalog?.catalogType === 2);
  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={isExternalSupplier ? false : true}
      className="!p-0"
      title={value}
    >
      {value}
    </GridCellBase>
  );
};

export default BrandNameCell;
